module.exports = __webpack_public_path__ + "static/media/main-logo.b96f3d2e.jpg";